// extracted by mini-css-extract-plugin
export default {"table":"_1di4","sm":"_3RFg","tableCell":"_1swD","bordered":"_1rtf","tableHeader":"_2grR","left":"_1qLY","right":"_1VxA","center":"aEfA"};